import { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import { useMfaApi } from '../../mfa/hooks/useMfaApi';

export default function useCheckForUpdateAccountCookie(setIsCheckingCookie: Dispatch<SetStateAction<boolean>>, setIsVerified: Dispatch<SetStateAction<boolean>>, wait: boolean = false) {
    const isCookieVerifiedRef = useRef(false);
    const { mfaVerifyCookie } = useMfaApi();

    useEffect(() => {
        if (wait || isCookieVerifiedRef.current) {
            return;
        }
        isCookieVerifiedRef.current = true;
        verifyUpdateAccountCookie();

        async function verifyUpdateAccountCookie() {
            const verifyResponse = await mfaVerifyCookie();
            setIsVerified(verifyResponse?.status === 200);
            setIsCheckingCookie(false);
        }

    }, [wait, mfaVerifyCookie, setIsVerified, setIsCheckingCookie]);

}